const VerifyMail = {
  SEND_MAIL_SUCCESS: 'SEND_MAIL_SUCCESS',
  SEND_MAIL_FAIL: 'SEND_MAIL_FAIL',
};

export default VerifyMail;
